import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";

Vue.use(VueI18n);

export const languages = [{ title: "English", value: "en" }];

let locale = "en";
let fallbackLocale = "en";

export default new VueI18n({
  locale,
  fallbackLocale,
  silentTranslationWarn: true,
  messages: {
    en
  }
});
